import styled from "@emotion/styled";
import { useCallback } from "react";

import { useFormatMessage } from "@skilitics/localization";

import { IconButton } from "../buttons";
import { Tooltip } from "../dataDisplay";
import { FieldColorPicker, FormRowField, useField, useFieldContext } from "../forms";
import { makePalette } from "./helpers";
import { paletteFormatStrings, type PlayerPalette } from "./types";

const CustomPaletteContainer = styled.div`
  display: block;
  width: 220px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
  margin-bottom: 10px;
`;

const AutoPaletteButton = styled(IconButton)`
  font-size: 16px;
`;

export const FieldPaletteInputs = () => {
  const formatMessage = useFormatMessage({ ...paletteFormatStrings, ...formatStrings });
  const { name } = useFieldContext();
  const [{ value }, _, { setValue }] = useField<PlayerPalette>(name);

  const handleClick = useCallback(() => {
    const autoPalette = makePalette({ main: value.main });
    void setValue(autoPalette);
  }, [setValue, value.main]);

  return (
    <CustomPaletteContainer data-test="custom-palette-container">
      <Tooltip title={formatMessage("main")} placement="left">
        <Row>
          <FormRowField name={`${name}.main`} explicitLabel>
            <FieldColorPicker />
          </FormRowField>
          <Tooltip title={formatMessage("autoButtonTooltip")}>
            <AutoPaletteButton icon="wand-magic-sparkles" onClick={handleClick} data-test="auto-button" />
          </Tooltip>
        </Row>
      </Tooltip>
      <Tooltip title={formatMessage("foreground")} placement="left">
        <Row>
          <FormRowField name={`${name}.foreground`} explicitLabel>
            <FieldColorPicker />
          </FormRowField>
        </Row>
      </Tooltip>
      <Tooltip title={formatMessage("light")} placement="left">
        <Row>
          <FormRowField name={`${name}.light`} explicitLabel>
            <FieldColorPicker />
          </FormRowField>
        </Row>
      </Tooltip>
      <Tooltip title={formatMessage("dark")} placement="left">
        <Row>
          <FormRowField name={`${name}.dark`} explicitLabel>
            <FieldColorPicker />
          </FormRowField>
        </Row>
      </Tooltip>
    </CustomPaletteContainer>
  );
};

const formatStrings = {
  autoButtonTooltip: {
    en: "Automatically compose a color palette from the main color.",
  },
};
